module.exports = __webpack_public_path__ + "static/media/wenhao3.329449db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wenhao3.png
// module id = 687
// module chunks = 0 1